import { Component } from "@kluntje/core";
import { fetchJSON } from "Helper/apiHelper";
import SSOService from "Services/SSOService";

/**
 * Custom Element to .. @TODO
 */
class FRAAccountdelete extends Component {
  SSOService = SSOService.getInstance();
  deletionMarked = false;

  constructor() {
    super({
      ui: {
        deleteButton: ".fra-e-account-delete",
        confirmButton: ".fra-e-account-delete--confirm",
        cancelButton: ".fra-e-account-delete--cancel",
        confirmMessage: ".fra-e-account-delete--confirm---message",
        errorMessage: ".fra-e-account-delete--error---message",
      },

      events: [
        {
          event: "click",
          target: "deleteButton",
          handler: "handleDeleteEvent",
        },
        {
          event: "click",
          target: "confirmButton",
          handler: "handleDeleteConfirmEvent",
        },
        {
          event: "click",
          target: "cancelButton",
          handler: "handleDeleteCancelEvent",
        },
      ],
    });
  }

  /**
   * @override
   */
  afterComponentRender() {
    this.show(this.ui.deleteButton);
    this.hide(this.ui.confirmButton);
    this.hide(this.ui.confirmMessage);
    this.hide(this.ui.errorMessage);
    this.hide(this.ui.cancelButton);
  }

  show(element: any) {
    element[0].style.display = "";
  }

  hide(element: any) {
    element[0].style.display = "none";
  }

  handleDeleteEvent() {
    console.log("Delete Event!");
    this.hide(this.ui.deleteButton);
    this.show(this.ui.confirmButton);
    this.show(this.ui.cancelButton);
    this.deletionMarked = true;
  }

  handleDeleteCancelEvent() {
    console.log("Cancel Event!");
    this.show(this.ui.deleteButton);
    this.hide(this.ui.errorMessage);
    this.hide(this.ui.cancelButton);
    this.hide(this.ui.confirmButton);
    this.deletionMarked = false;
  }

  handleDeleteConfirmEvent() {
    console.log("Confirm Event!");

    if (this.deletionMarked) {
      const jsonurl = this.getAttribute("data-operation-url") || "";
      const ssoService = this.SSOService;
      fetchJSON(jsonurl)
        .then(() => {
          this.show(this.ui.confirmMessage);
          setTimeout(function () {
            ssoService.logOut();
            location.reload();
          }, 1000);
        })
        .catch(() => {
          this.show(this.ui.errorMessage);
        });

      this.hide(this.ui.deleteButton);
      this.hide(this.ui.confirmButton);
      this.hide(this.ui.cancelButton);
      this.deletionMarked = false;
    } else {
      this.show(this.ui.errorMessage);
      this.hide(this.ui.deleteButton);
      this.hide(this.ui.confirmButton);
      this.show(this.ui.cancelButton);
    }
  }
}

customElements.define("fra-e-accountdelete", FRAAccountdelete);

export default FRAAccountdelete;
